import { AxiosError } from 'axios';

import { ZEE_DOCUMENT_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeeDocument } from '@/types/zee.document.type';

export type CreateZeeDocumentApiPayload = {
  file_name: string;
  file_url: string;
  file_size: number;
  stage_name: string;
  stage_item_title: string;
  stage_item_description: string;
};

export const createZeeDocument = async (
  payload: CreateZeeDocumentApiPayload
): Promise<ApiResponse<ZeeDocument>> => {
  try {
    const response = await apiManager.post(ZEE_DOCUMENT_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
